import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=af15b408&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=af15b408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af15b408",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
